import { createContext, useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, Zoom } from "react-toastify";
import { useDispatch } from "react-redux";
import PageSpinner from "../Components/Spinners/pageSpinner";
import 'react-toastify/dist/ReactToastify.css';
import LogoAnimation from "../Components/Animation/LogoAnimation.jsx";
import { setIsShowAuthModal, setUserData, setUserToken } from "../Store/Reducers/userReducer";

export const ModalContext = createContext(null);

function Layaut(props) {

  const dispatch = useDispatch()
  const navigate = useNavigate();
  let storageToken = localStorage.getItem("token");
  const { token } = useParams();

  useEffect(() => {
    if (!token && storageToken) {
      navigate(`/${storageToken}`)
    }
    if (token !== storageToken) {
      dispatch(setUserData(null));
      dispatch(setUserToken(""));
      dispatch(setIsShowAuthModal(false));
    }
  }, [token, storageToken])

  const [modalContent, setModalContent] = useState({
    show: false,
    title: "",
    children: null,
  });


  return (
    // Context - for footer modals
    <ModalContext.Provider value={{
      modalContent,
      setModalContent
    }}>
      {/* <Header /> */}
      <Outlet />
      <ToastContainer
        theme="colored"
        position="bottom-left"
        autoClose={4000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Zoom}
      />
      <PageSpinner />
      {
        !storageToken ?
          <div className="animation-logo">
            <LogoAnimation />
          </div>
          : null
      }
    </ModalContext.Provider>
  );
}

export default Layaut;